import React from "react";

import styles from "./Step.module.scss";

export interface Props {
  isActive?: boolean;
  isCompleted?: boolean;
  handleClick?: () => void;
  label: string;
  labelMobile: string;
}

export const Step = ({ isActive, isCompleted, handleClick, label, labelMobile }: Props) => (
  <li
    aria-current={isActive ? "step" : "false"}
    onClick={handleClick}
    className={`${styles.step__wrapper} ${isActive ? styles["step__wrapper--active"] : ""} ${
      isCompleted && !isActive ? styles["step__wrapper--completed"] : ""
    }`}
  >
    <span className="hide-mobile">{label}</span>
    <span className="hide-desktop">{labelMobile}</span>
  </li>
);
